import { baseAxios } from "./apiDefault";
import promiseHandler from "@/utils/promise";

export const refreshAllToken = async data =>
  promiseHandler(baseAxios().put("/auth/api/v1.0/refresh", data));

export const login = async data => {
  return promiseHandler(baseAxios().post("auth/api/v1.0/signin", data));
};

export const logout = async data =>
  promiseHandler(baseAxios().post("auth/api/v1.0/signout", data));

export const register = async data =>
  promiseHandler(baseAxios().post("auth/api/v1.0/signup", data));

export const phoneVerificationToken = async data =>
  promiseHandler(
    baseAxios().post("auth/api/v1.0/sms/sendPhoneVerificationToken", data)
  );

export const emailVerificationToken = async data =>
  promiseHandler(
    baseAxios().post("auth/api/v1.0/email/sendEmailVerificationToken", data)
  );

export const forgotPasswordWithPhone = async data =>
  promiseHandler(
    baseAxios().post("auth/api/v1.0/password/ResetPassword", data)
  );

export const forgotPassword = async data =>
  promiseHandler(
    baseAxios().post("auth/api/v1.0/email/sendResetPasswordToken", data)
  );

export const resetPassword = async data =>
  promiseHandler(baseAxios().put("auth/api/v1.0/password/resetPassword", data));

export const verifyToken = async data =>
  promiseHandler(baseAxios().post("auth/api/v1.0/verify/Token", data));

export const phoneVerification = async data =>
  promiseHandler(baseAxios().post("auth/api/v1.0/verify/phoneNumber", data));

export const emailVerification = async data =>
  promiseHandler(baseAxios().post("auth/api/v1.0/verify/email", data));
